<div class="p-3">

  <p class="is-bold is-size-5 color-darkblue has-text-centered mb-4">
    Weitere Informationen erforderlich
  </p>

  <p class="is-bold">Für die Beschaffung der Bewilligungsurkunde sind weitere Informationen erforderlich.</p>

  <p class="is-bold is-size-6 mt-4">Grundbuchblatt-Nr.</p>

  <app-folio-number [property]="selectedProperty" [displayAdditionalCostInformation]="false"></app-folio-number>

  <ng-container *ngIf="ProductUtils.shouldOpenProductValueDialog([bewilProduct]) else defaultButtons">
    <hr>
    <app-product-value-form [products]="[bewilProduct]" [property]="selectedProperty" [hasPadding]="false"
                            [displayCancelButton]="true" [cancelButtonText]="'Abbrechen'" [confirmButtonText]="'Weiter'"
                            (confirmModalEvent)="addBewilDocument()"
                            [displayHeader]="false" [displayDocName]="false"
                            (cancelModalEvent)="closeModal()"></app-product-value-form>
  </ng-container>

  <ng-template #defaultButtons>
    <div class="columns is-justify-content-end mt-4">
      <div class="column is-one-third">
        <a (click)="closeModal()" class="no-border back-button is-size-6 has-round-border has-text-centered">
          <div class="columns full-width">
            <div class="column is-12 is-bold relative is-flex is-justify-content-center is-align-items-center">
              <img alt="Arrow Left" src="assets/images/button/left_btn.svg" class="absolute left-0">
              <p>Abbrechen</p>
            </div>
          </div>
        </a>
      </div>
      <div class="column is-one-third"></div>
      <div class="column is-one-third">
        <a (click)="addBewilDocument()" class="no-border buy-button is-size-6 has-round-border has-text-centered">
          <div class="columns full-width">
            <div class="column is-12 is-bold relative">
              <p>Weiter</p>
              <img alt="Arrow Right" src="assets/images/button/right_btn.svg" class="absolute has-text-right">
            </div>
          </div>
        </a>
      </div>

    </div>
  </ng-template>
</div>
